import {
  IconRefresh,
  IconTargetArrow,
  IconUsers,
  IconListCheck,
  IconCashBanknote,
  IconBinaryTree,
  IconFileDollar,
  IconForms,
  IconTableOptions,
  IconUpload,
  IconChartBar,
  IconCertificate,
  IconSettings,
  IconAccessPoint,
  IconHistoryToggle,
  IconBuilding,
  IconHelp,
  IconArrowsExchange2,
  IconPercentage,
  IconSquareKey,
  IconBriefcase,
  IconFolders,
  IconSparkles,
  IconTrash,
  IconPresentationAnalytics,
  IconDotsVertical,
  IconChartPie,
  IconHistory,
  IconToolsKitchen2,
  IconSpy,
  IconRouteSquare,
  IconPlus,
  IconFlask,
  IconDownload,
  IconAlertTriangle,
  IconClockPlay,
  IconCheck,
  IconLock,
  IconUserSquare,
  IconStackPop,
  IconBarcode,
  IconTrack,
  IconCircuitResistor,
  IconCurrencyDollar,
  IconWorld,
  IconCake,
  IconUsersGroup,
  IconFileDescription,
  IconFileTypography,
  IconDeviceFloppy,
  IconArrowBackUp,
  IconZoomExclamation,
  IconEyeOff,
  IconEye,
  IconPencil,
  IconChevronLeft,
  IconRotateClockwise2,
  IconMapPin,
  Icon3dCubeSphere,
  IconX,
  IconBrandCitymapper,
  IconClipboardList,
  IconMoodCog,
  IconStack3,
  IconLayoutColumns,
} from "@tabler/icons-react";

import { IconLayoutListOffset } from "./custom/IconLayoutListOffset";

export const AppIcon = {
  GettingStarted: IconListCheck,
  Employees: IconUsers,
  Ranges: IconLayoutListOffset,
  Cycles: IconRefresh,
  Benchmarking: IconTargetArrow,
  TotalRewards: IconCashBanknote,
  Settings: IconSettings,
  AdminTools: IconToolsKitchen2,
  ExecCompSurvey: IconPresentationAnalytics,
  VcDashboard: IconClipboardList,

  // global features
  Analytics: IconChartBar,
  TableSettings: IconTableOptions,
  AI: IconSparkles,
  Impersonation: IconSpy,

  // cycles secondary features
  Notes: IconFileDescription,
  AwardLetters: IconCertificate,

  // employees secondary features
  Manage: IconBriefcase,

  // ranges secondary features
  RangeSets: IconStack3,
  JobArchitecture: IconBinaryTree,
  PayPoints: IconFileDollar,
  MappingSettings: IconBrandCitymapper,
  CustomFields: IconForms,
  AutoBenchmarking: IconRouteSquare,
  Columns: IconLayoutColumns,

  // tr secondary features
  EmployeePreview: IconPresentationAnalytics,

  // settings seconary features
  Integrations: IconAccessPoint,
  SyncHistory: IconHistoryToggle,
  IntegrationSync: IconRotateClockwise2,
  Dataset: Icon3dCubeSphere,

  Company: IconBuilding,
  Glossary: IconHelp,
  ExchangeRates: IconArrowsExchange2,
  EquityGrants: IconPercentage,
  Permissions: IconSquareKey,
  Files: IconFolders,
  Equity: IconChartPie,
  CompHistory: IconHistory,
  // AwardLetterCoaching: IconSparkles,
  AwardLetterCoaching: IconMoodCog,
  Performance: IconChartBar,

  // job architecture
  Families: IconUserSquare,
  Level: IconStackPop,
  Zone: IconWorld,
  Seniority: IconCake,
  JobFamilyGroup: IconUsersGroup,
  JobCode: IconBarcode,
  Track: IconTrack,
  PayFrequency: IconCircuitResistor,

  // status
  InProgress: IconClockPlay,
  Completed: IconCheck,
  Locked: IconLock,
  Success: IconCheck,

  // ux / actions
  MoreOptions: IconDotsVertical,
  Delete: IconTrash,
  ToolTip: IconHelp,
  Add: IconPlus,
  Edit: IconPencil,
  Help: IconHelp,
  Experiment: IconFlask,
  Warning: IconAlertTriangle,
  AIGenerate: IconRefresh,
  Currency: IconCurrencyDollar,
  File: IconFileDescription,
  Hide: IconEyeOff,
  Show: IconEye,
  Back: IconChevronLeft,
  Location: IconMapPin,
  RichText: IconFileTypography,
  Download: IconDownload,
  Upload: IconUpload,
  Save: IconDeviceFloppy,
  Revert: IconArrowBackUp,
  NotFound: IconZoomExclamation,
  Close: IconX,
};
